export default "__VITE_ASSET__CwiN6zjK__"